import React, { useEffect, useState } from "react";
import ButtonBookNow from "./ButtonBookNow";
import PolicyBanner from "./PolicyBanner";
import "./HeroSectionNew.css";

const HeroSectionNew = () => {
  const [shopName, setShopName] = useState("");
  const [slogan, setSlogan] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchShopData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/controllers/fetch_hero.php?id=1`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const { data } = await response.json();
        setShopName(data.shop_name);
        setSlogan(data.slogan);
      } catch (error) {
        console.error("Error fetching shop name:", error);
        setError(error.message);
      }
    };

    fetchShopData();
  }, []);

  return (
    <div className="mb-5">
      <section className="hero-section-new">
        {error && <div className="hero-error">Ett fel uppstod: {error}</div>}
        <div className="hero-text-new">
          <h1>{shopName}</h1>
          <p>{slogan}</p>
        </div>
        <div className="hero-button-bottom">
          <ButtonBookNow />
        </div>
      </section>
      <PolicyBanner />
    </div>
  );
};

export default HeroSectionNew;
